/**
 * Returns an S3 key, given an S3 URL.
 *
 * Example:
 * getS3KeyFromUrl('https://my-bucket.s3.amazonaws.com/foo/bar.jpg) // returns 'foo/bar.jpg'
 * @param url
 */
export const getS3KeyFromUrl = (url: string): Maybe<string> => {
    const match = url.match(/s3.amazonaws.com\/(.*)$/);

    return match?.[1] ?? null;
};
